<template>
  <ContactPage />
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContactPage from 'chimera/all/components/page/ContactPage.vue'

export default {
  components: {
    ContactPage,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Contactez-nous!',
      headDescription:
        'Vous pouvez contacter Comparateurdagencesimmobilieres.be en remplissant le formulaire de contact.',
      path: '/contact',
    }
  },
}
</script>
